import { render, staticRenderFns } from "./ResponsableFirma.vue?vue&type=template&id=07addb31"
import script from "./ResponsableFirma.vue?vue&type=script&lang=js"
export * from "./ResponsableFirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports